import { Stack } from "@similarweb/ui-components/foundations";

import { TableNoData } from "app/components/table-no-data/TableNoData";
import type { IWidget } from "app/components/widget/widget-types/Widget";

interface IWidgetStateErrorMessageProps<T> {
    widget: IWidget<T>;
}

export const WidgetStateErrorMessage = <T,>({ widget }: IWidgetStateErrorMessageProps<T>) => {
    return (
        <Stack
            justifyContent="center"
            height="100%"
        >
            <TableNoData config={widget.errorConfig} />
        </Stack>
    );
};
